import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import updateObjetivo from "../../services/Objetivos/updateObjetivo";
import { useDispatch } from "react-redux";

import FormObjetivo from "./FormObjetivo";
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import { clear } from "../../../redux/reducers/Glosario/terminosSlice";
import { changeOnly } from "../../../redux/reducers/Glosario/filtroSlice";

const useStyles = makeStyles((theme) => ({
  button: {
    textAlign: "center",
    left: "90%",
    background: "silver",
  },
  buttonSubmit: {
    textAlign: "center",
    left: "40%",
    background: "silver",
    top: 15,
  },

  valor: {
    cursor: "pointer",
  },

  formControl: {
    margin: theme.spacing(-2),
    minWidth: 250,
    Width: 300,
  },
  selectEmpty: {
    marginTop: theme.spacing(1),
  },

  MuiTextField: {
    align: "left",
    m: 5,
    width: 300,
  },

  root: {
    "& > *": {
      margin: theme.spacing(3),

      left: "-3%",
      background: "silver",
      top: 15,
    },
  },
}));

const ModalModificarObjetivo = ({ item, valor }) => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const [show, setShow] = useState(true);
  const [nombre1, setNombre1] = useState(false);

  const handleClose = () => {
    setShow(!show);
    setNombre1(false);
    valor({});
  };

  const handleClick = (data) => {
    updateObjetivo(data, item.item.id).then(() => {
      setShow(false);
      valor({});
      dispatch(clear());
      dispatch(changeOnly([]));
    });
  };

  return (
    <>
      <div className={styles.root}>
        <Modal show={show} onHide={handleClose} backdrop="static" centered>
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Modificar
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormObjetivo
              onSubmit={handleClick}
              defaultData={{
                nombre: item.item.nombre,
                definicion: item.item.definicion,
                fuente: item.item.fuente,
                glosario: item.item.glosario,
              }}
              nombre1={nombre1}
            />
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default ModalModificarObjetivo;
